export const ADD_GENERATION = 'ADD_GENERATION';
export const DELETE_GENERATION = 'DELETE_GENERATION';
export const RESET_GENERATIONS = 'RESET_GENERATIONS';
